import { Injectable, signal } from '@angular/core';
import { GlossaryEntry } from './glossary.service';

/**
 * Centralised state for the shared glossary overlay (GAP-FU-12).
 *
 * Single overlay instance lives in `app.component.html`. The
 * GlossaryDirective calls `show(entry, anchorRect)` on hover/focus
 * and `hide()` on leave/blur. Keeping one shared instance avoids
 * the cost of one DOM tooltip per inline term.
 */
@Injectable({ providedIn: 'root' })
export class GlossaryOverlayService {
  private readonly _entry = signal<GlossaryEntry | null>(null);
  private readonly _anchor = signal<DOMRect | null>(null);
  private readonly _token = signal<string | null>(null);

  readonly entry = this._entry.asReadonly();
  readonly anchor = this._anchor.asReadonly();
  readonly token = this._token.asReadonly();

  show(token: string, entry: GlossaryEntry, anchor: DOMRect): void {
    this._token.set(token);
    this._entry.set(entry);
    this._anchor.set(anchor);
  }

  hide(): void {
    this._token.set(null);
    this._entry.set(null);
    this._anchor.set(null);
  }
}
